export default __webpack_public_path__ + "static/media/float-left.917812e3.svg";